export enum ConversationStatus {
  ACTIVE = 'active',
  NEW = 'new',
  ENDED = 'ended',
}
